export const VERSION = '0.91.1'; // x-release-please-version
//# sourceMappingURL=version.mjs.map